import {
  getActiveLocations,
  getLicenses,
  LicenseTypes,
} from "@enos-monorepo/lib";
import { useQuery } from "@tanstack/react-query";

import { useCompany } from "./useCompany";

export function useLicensesControl() {
  const { company, isPending } = useCompany();

  const { data: locations, isPending: locationsIsPending } = useQuery({
    queryKey: ["locations", company?.companyId],
    queryFn: () => getActiveLocations(company?.companyId ?? ""),
    enabled: !!company?.companyId,
  });

  const { data: licenses, isPending: licencesIsPending } = useQuery({
    queryKey: ["locationLicenses"],
    queryFn: () => getLicenses(locations ?? []),
    enabled: !!locations,
  });

  const flattenedLicenses =
    licenses?.flat().flatMap((license) => license.data) || [];

  console.log({
    company,
    isPending,
    locationsIsPending,
    licencesIsPending,
  });

  return {
    shift: flattenedLicenses?.some(
      (al) => al.moduleName === LicenseTypes.shift,
    ),
    food: flattenedLicenses?.some((al) => al.moduleName === LicenseTypes.food),
    isPending:
      (company && (locationsIsPending || licencesIsPending)) || isPending,
  };
}
